"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalVideoPlayer = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouter = require("react-router");

var _reactRedux = require("react-redux");

var _ = require("../../");

var _VideoPlayer = require("../../organisms/VideoPlayer");

var _getTrackingCategory = require("../../util/getTrackingCategory");

var _getProperty = require("../../util/getProperty");

var _excluded = ["moments", "momentId", "cameraName", "containerRef", "trackingCategory", "trackingAction", "previewMode", "disabledControls", "onSourceChange", "multicam", "toaster"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ModalVideoPlayer = function ModalVideoPlayer(_ref) {
  var moments = _ref.moments,
      momentId = _ref.momentId,
      cameraName = _ref.cameraName,
      containerRef = _ref.containerRef,
      trackingCategory = _ref.trackingCategory,
      trackingAction = _ref.trackingAction,
      _ref$previewMode = _ref.previewMode,
      previewMode = _ref$previewMode === void 0 ? false : _ref$previewMode,
      disabledControls = _ref.disabledControls,
      onSourceChange = _ref.onSourceChange,
      multicam = _ref.multicam,
      toaster = _ref.toaster,
      props = _objectWithoutProperties(_ref, _excluded);

  var history = (0, _reactRouter.useHistory)();
  var dispatch = (0, _reactRedux.useDispatch)();

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      paused = _useState2[0],
      setPaused = _useState2[1];

  var _useFluidPlayer = (0, _VideoPlayer.useFluidPlayer)(containerRef, {
    paused: true
  }),
      play = _useFluidPlayer.play,
      pause = _useFluidPlayer.pause,
      onItemChanged = _useFluidPlayer.onItemChanged,
      goToNext = _useFluidPlayer.goToNext,
      goToPrev = _useFluidPlayer.goToPrev,
      setItems = _useFluidPlayer.setItems,
      handleVideoInfoUpdate = _useFluidPlayer.handleVideoInfoUpdate,
      playlistController = _useFluidPlayer.playlistController;

  (0, _react.useEffect)(function () {
    handleVideoInfoUpdate(function (info) {
      if (paused !== info.paused) {
        setPaused(info.paused);
      }
    });
  }, [paused, handleVideoInfoUpdate]);

  var toast = function toast(show, msg) {
    if (typeof toaster === "function") {
      toaster(show, msg);
    }
  }; // generate cameras from moment


  var cameras = (0, _react.useMemo)(function () {
    if (multicam == false) {
      return undefined;
    }

    var cameras = [];
    var cm = null;

    if (moments) {
      var _iterator = _createForOfIteratorHelper(moments),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var m = _step.value;

          if (m.game_clip_id == momentId) {
            cm = m;
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    if (multicam && cm) {
      var graphCamera = (0, _getProperty.getProperty)("camera", cm, null);
      var metaCamera = (0, _getProperty.getProperty)("meta.camera", cm, null);

      if (graphCamera) {
        cameras = [graphCamera];
      } else if (metaCamera) {
        cameras = [metaCamera];
      } else {
        console.warn("No camera on parent moment", cm);
        cameras = [];
      }

      if (cm.sources) {
        var _iterator2 = _createForOfIteratorHelper(cm.sources),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var source = _step2.value;
            var gCamera = (0, _getProperty.getProperty)("camera", source, null);
            var mCamera = (0, _getProperty.getProperty)("meta.camera", source, null);

            if (gCamera) {
              cameras.push(gCamera);
            } else if (mCamera) {
              cameras.push(mCamera);
            } else {
              console.warn("No camera on source moment", source);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }

    return cameras;
  }, [moments, momentId, multicam]);
  var noMulticam = !multicam || !(cameras && cameras.length > 0);
  (0, _react.useEffect)(function () {
    if (!moments) {
      return;
    }

    if (!cameras && multicam) {
      return;
    }

    if (!playlistController) {
      console.log("No playlist controller");
      return;
    }

    var id = momentId;

    if (!id && moments.length > 0) {
      id = moments[0].game_clip_id;
    }

    console.log("ModalVideoPlayer settings items");
    setItems(moments, id);
  }, [moments, playlistController]); //// Handlers
  // useEffect(() => {
  //     document.addEventListener("trc-source-changed", onSourceChange)
  //     return () => {
  //         document.removeEventListener("trc-source-changed", onSourceChange)
  //     }
  // }, [onSourceChange, momentId, cameraName])
  // Moment navigation

  (0, _react.useEffect)(function () {
    onItemChanged(function (item) {
      if (!previewMode) {
        var parts = history.location.pathname.split("/");
        parts[parts.length - 1] = item.game_clip_id;
        history.push(parts.join("/"));
      }
    });
  }, [onItemChanged, history, previewMode]); //// Video Keyboard Shortcuts
  // Play/Play via Spacebar

  (0, _.useHotKeyHandler)([" "], (0, _react.useCallback)(function () {
    if (paused) {
      dispatch(toast(true, "Play"));
      play();
    } else {
      dispatch(toast(true, "Pause"));
      pause();
    }
  }, [paused, play, pause]), {
    preventDefault: true
  }); // Next

  (0, _.useHotKeyHandler)(["Enter"], (0, _react.useCallback)(function () {
    dispatch(toast(true, "Next"));
    goToNext();
  }, [goToNext])); // ArrowRight

  (0, _.useHotKeyHandler)(["ArrowRight"], (0, _react.useCallback)(function () {
    dispatch(toast(true, "Next"));
    goToNext();
  }, [goToNext])); // ArrowRight

  (0, _.useHotKeyHandler)(["ArrowLeft"], (0, _react.useCallback)(function () {
    dispatch(toast(true, "Previous"));
    goToPrev();
  }, [goToPrev]));
  return /*#__PURE__*/_react.default.createElement(_VideoPlayer.VideoContainer, _extends({}, props, {
    containerRef: containerRef,
    videoSettingsKey: "trace_id",
    radar: true,
    cameras: cameras,
    trackingPlaylistType: "user_playlists",
    trackingCategory: (0, _getTrackingCategory.getTrackingCategory)(),
    trackingAction: trackingAction,
    trackingPlayerType: "Modal",
    fullScreenElementSelector: ".MyMomentPlayer .VideoContainer .VideoPlayer",
    disabledControls: disabledControls,
    defaultCamera: cameraName,
    noMulticam: noMulticam,
    toaster: toast
  }));
};

exports.ModalVideoPlayer = ModalVideoPlayer;